// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class NlpTranscriptEventName {
  static DismissXaCard: string = 'dismissXaCard';
}
